import { PrismUI, builderDispatch } from '../../_utils/ui';
import { usePrismItemStore } from 'stores/usePrismItemStore';

function autofillOnImageUploadNormal(
  imageList,
  autofillTarget,
  autofillStrategy,
) {
  const options = {
    clear_existing: autofillTarget === 'all',
  };

  switch (autofillStrategy) {
    case 'by_name':
      options.image_ids = imageListSortedByName().map((image) => image.id);
      break;
    case 'by_date':
      options.strategy = 'by_date';
      break;
    default:
      options.image_ids = Array.from(imageList, (image) => image.id);
      break;
  }

  builderDispatch
    .delayedDispatch({ type: PrismUI.EVENT_AUTO_FILL })
    .then(() => {
      usePrismItemStore.getState().autofill(options);
    });
}

function imageListSortedByName() {
  const prismItem = usePrismItemStore.getState().prismItem;
  return prismItem.imageList.sort((imageA, imageB) => {
    const nameA =
      imageA.name.substr(0, imageA.name.lastIndexOf('.')) || imageA.name;
    const nameB =
      imageB.name.substr(0, imageB.name.lastIndexOf('.')) || imageB.name;

    if (Number(nameA)) {
      if (Number(nameB)) {
        return nameA < nameB ? -1 : 1;
      }

      return -1;
    }

    if (Number(nameB)) return 1;
    return nameA < nameB ? -1 : 1;
  });
}

export { autofillOnImageUploadNormal };
